<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<a id="page_7">
<p class="chap-title paracenter" style="font-size:2em!important;margin-top:4em!important;margin-bottom:3em!important;"><b>Contents</b></p>
</a><p class="parahangblk1"><a id="page_7"></a><a href="#/text/09_acknowledgement#ack" id="ack">Acknowledgements</a></p>
<p class="parahangblk1"> </p>
<p class="parahangblk1"><a href="#/text/10_prologue#pro" id="pro">Prologue</a></p>
<p class="parahangblk1"><a href="#/text/11_chapter1#ch1" id="ch1">The Funeral</a></p>
<p class="parahangblk1"><a href="#/text/12_chapter2#ch2" id="ch2">Georgi Markov, London, September 1978</a></p>
<p class="parahangblk1"><a href="#/text/13_chapter3#ch3" id="ch3">The KGB’s Poison Factory</a></p>
<p class="parahangblk1"><span href="#/text/14_chapter4#ch4" id="ch4" title="Link target outside of Sample">Those were the days</span></p>
<p class="parahangblk1"><span href="#/text/15_chapter5#ch5" id="ch5" title="Link target outside of Sample">Litvinenko: Operation <span class="small">VLADIMIR</span>, Part I</span></p>
<p class="parahangblk1"><span href="#/text/16_chapter6#ch6" id="ch6" title="Link target outside of Sample">Victor Yushchenko, the Ukrainian Patient, Kiev, September 2004</span></p>
<p class="parahangblk1"><span href="#/text/17_chapter7#ch7" id="ch7" title="Link target outside of Sample">Béla Lapusnyik, the victim, Vienna, May 1962</span></p>
<p class="parahangblk1"><span href="#/text/18_chapter8#ch8" id="ch8" title="Link target outside of Sample">Nikolai Artamonov, the triple agent, Vienna, December 1975</span></p>
<p class="parahangblk1"><span href="#/text/19_chapter9#ch9" id="ch9" title="Link target outside of Sample">Litvinenko: Operation <span class="small">VLADIMIR</span>, Part II</span></p>
<p class="parahangblk1"><span href="#/text/20_chapter10#ch10" id="ch10" title="Link target outside of Sample">Nikolai Khokhlov, the illegal, Germany, 1954–7</span></p>
<p class="parahangblk1"><span href="#/text/21_chapter11#ch11" id="ch11" title="Link target outside of Sample">Bogdan Stashinsky, the assassin, Germany, 1957–9</span></p>
<p class="parahangblk1"><span href="#/text/22_chapter12#ch12" id="ch12" title="Link target outside of Sample">Litvinenko: Operation <span class="small">VLADIMIR</span>, Part III</span></p>
<p class="parahangblk1"><span href="#/text/23_chapter13#ch13" id="ch13" title="Link target outside of Sample">Dead Souls: From Stalin to Putin</span></p>
<p class="parahangblk1"><span href="#/text/24_epilogue#epi" id="epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="parahangblk1"> </p>
<p class="parahangblk1"><span href="#/text/25_notes#not" id="not" title="Link target outside of Sample">Notes</span></p>
<p class="parahangblk1"><span href="#/text/26_appendix#app" id="app" title="Link target outside of Sample">Appendix: Selected Soviet and Russian operations abroad: from Lenin to Litvinenko and beyond</span></p>
<p class="parahangblk1"><span href="#/text/27_selectbibliography#bib" id="bib" title="Link target outside of Sample">Select Bibliography</span></p>
<p class="parahangblk1"><span href="#/text/28_index#ind" id="ind" title="Link target outside of Sample">Index</span></p>
<a id="page_8">
</a></div><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_toc.vue?05bac312